import Swiper from 'swiper/bundle';

const Carousels = {
    genericMobileCarousel: () => {
        let carousels = $('.generic-mobile-carousel');
        let destroyCarouselBreakpoint = window.matchMedia('(min-width: 768px)');

        if (!carousels.length) return;

        $.each(carousels, (index, element) => {
            let swiper;

            const onBreakpointChange = () => {
                swiper = Carousels.handleCarouselBreakpointMatch(
                    destroyCarouselBreakpoint,
                    swiper,
                    element,
                    {
                        slidesPerView: 'auto',
                        spaceBetween: 20,
                        loop: true,
                        loopedSlides: $(element).find('.swiper-slide').length,
                        pagination: {
                            el: '.swiper-pagination',
                            type: 'progressbar'
                        }
                    }
                );
            };

            destroyCarouselBreakpoint.addEventListener(
                'change',
                onBreakpointChange
            );
            onBreakpointChange();
        });
    },

    gridCarousel: () => {
        let carousels = $('.grid-carousel');
        let destroyCarouselBreakpoint = window.matchMedia(
            '(min-width: 1024px)'
        );

        if (!carousels.length) return;

        $.each(carousels, (index, gc) => {
            let gridCarouselCaptions = $(gc).find('.grid-carousel-captions');
            let gridCarouselContent = $(gc).find('.grid-carousel-content');
            let gridCarouselImages = $(gc).find('.grid-carousel-images');
            let captionTexts = gridCarouselCaptions.find('.swiper-slide');
            let activeCaptionClasses = '';
            let inactiveCaptionClasses = '';
            let carouselsToControl = [];
            let captionSwiper;
            let contentSwiper;
            let imageSwiper;
            let autoplayOptions = {
                delay: 30000,
                disableOnInteraction: false
            };

            if (gridCarouselContent.length) {
                contentSwiper = Carousels.startSwiper(gridCarouselContent[0], {
                    allowTouchMove: false,
                    autoHeight: true,
                    effect: 'fade',
                    fadeEffect: { crossFade: true }
                });
                carouselsToControl.push(contentSwiper);

                activeCaptionClasses = 'lg:opacity-100 lg:opacity-60';
                inactiveCaptionClasses = 'lg:opacity-60';
            } else {
                activeCaptionClasses = 'opacity-100 opacity-60';
                inactiveCaptionClasses = 'opacity-60';
            }

            imageSwiper = Carousels.startSwiper(gridCarouselImages[0], {
                allowTouchMove: false,
                autoplay: gridCarouselContent.length ? false : autoplayOptions,
                effect: 'fade',
                fadeEffect: { crossFade: true },
                on: {
                    autoplay: function() {
                        $(captionTexts[this.realIndex]).trigger('click');
                    }
                }
            });
            carouselsToControl.push(imageSwiper);

            captionTexts.map((index, captionText) => {
                let _captionText = $(captionText);

                _captionText.on('click', e => {
                    if (
                        !destroyCarouselBreakpoint.matches &&
                        gridCarouselContent.length
                    )
                        return;

                    _captionText
                        .toggleClass(activeCaptionClasses)
                        .siblings()
                        .removeClass(
                            'first:opacity-100 ' + activeCaptionClasses
                        )
                        .addClass(inactiveCaptionClasses);

                    if (e.originalEvent !== 'undefined')
                        imageSwiper.slideTo(index);
                    if (gridCarouselContent.length)
                        contentSwiper.slideTo(index);
                });
            });

            const onBreakpointChange = () => {
                captionSwiper = Carousels.handleCarouselBreakpointMatch(
                    destroyCarouselBreakpoint,
                    captionSwiper,
                    gridCarouselCaptions[0],
                    {
                        controller: { control: carouselsToControl },
                        navigation: {
                            disabledClass:
                                'swiper-button-disabled opacity-50 pointer-events-none',
                            nextEl: '.bb-nav-circle-right',
                            prevEl: '.bb-nav-circle-left'
                        },
                        autoplay: autoplayOptions,
                        on: {
                            init: function() {
                                this.slideTo(imageSwiper.realIndex, 0);
                            },
                            slideChange: function() {
                                captionTexts
                                    .removeClass(
                                        'first:opacity-100 ' +
                                            activeCaptionClasses
                                    )
                                    .addClass(inactiveCaptionClasses);
                                $(captionTexts[this.realIndex]).toggleClass(
                                    activeCaptionClasses
                                );
                            }
                        }
                    }
                );

                if (destroyCarouselBreakpoint.matches) {
                    imageSwiper.params.autoplay = autoplayOptions;
                    imageSwiper.autoplay.start();
                } else {
                    imageSwiper.autoplay.stop();
                }
            };

            if (gridCarouselContent.length) {
                destroyCarouselBreakpoint.addEventListener(
                    'change',
                    onBreakpointChange
                );
                onBreakpointChange();
            }
        });
    },

    flowerCardCarousel: () => {
        let carousels = $('.flower-card-carousel');

        if (!carousels.length) return;

        $.each(carousels, (index, element) => {
            let cards = $(element).find('.flower-card');

            const onWindowResize = () => {
                cards
                    .css('height', '')
                    .sort((a, b) => {
                        return b.offsetHeight - a.offsetHeight;
                    })
                    .outerHeight(cards[0].offsetHeight);
            };

            window.addEventListener('resize', onWindowResize);
            setTimeout(() => {
                onWindowResize();
            }, 1000);
        });
    },

    handleCarouselBreakpointMatch: (
        breakpoint,
        swiperInstance,
        swiperElement,
        swiperElementConfig
    ) => {
        if (breakpoint.matches) {
            if (!swiperInstance) return;

            if (swiperInstance.initialized) swiperInstance.destroy(true, true);

            return;
        } else {
            return Carousels.startSwiper(swiperElement, swiperElementConfig);
        }
    },

    startSwiper: (element, config) => {
        if ($(element).find('.swiper-slide').length === 1) return false;

        return new Swiper(element, $.extend({}, {}, config));
    },

    init: () => {
        Carousels.gridCarousel();
        Carousels.genericMobileCarousel();
        Carousels.flowerCardCarousel();
    }
};

Carousels.init();
